import Repository from "./Repository";

export default {
  getAdminPaymentStates(payload) {
    return Repository.get(`chats-annual-report/${payload}`);
  },
};
